/*
 * Copyright (c) 2024 CalAmp Corp. All Rights Reserved
 */

interface useScheduleDeviceSyncMaxExceeded {
  allRowsSelected?: boolean;
  rowCount?: number;
  selectedCount?: number;
  pastedIds?: number;
};

const MAX_DEVICES_SELECTED = 10000;

/**
 * React Hook to provide utility for Schedule DeviceSync Maximun Limit Exceeded functionality.
 *
 *  ```typescript
 *   import {useScheduleDeviceSyncMaxExceeded} from '@ion/applications/src/bulk';
 *
 *   const {isMaxExceeded} = useScheduleDeviceSyncMaxExceeded({
 *     allRowsSelected,
 *     rowCount,
 *     selectedCount,
 *     pastedIds
 *   });
 *
 *  ```
 */
export const useScheduleDeviceSyncMaxExceeded = ({
  allRowsSelected,
  rowCount,
  selectedCount,
  pastedIds
}: useScheduleDeviceSyncMaxExceeded): boolean => {
  const isMaxExceeded = (
    (allRowsSelected && rowCount > MAX_DEVICES_SELECTED) ||
     selectedCount > MAX_DEVICES_SELECTED ||
     pastedIds > MAX_DEVICES_SELECTED
  );
  return isMaxExceeded;
};

export default useScheduleDeviceSyncMaxExceeded;
